<template>
  <b-row>
    <b-col md="6">
      <el-form-item label="Tỉnh/Thành phố">
        <el-select
          v-model="ruleForm.provice"
          placeholder="Chọn Tỉnh/Thành phố"
          @change="getListDistrict"
          :disabled="this.disabled"
        >
          <el-option
            v-for="item in listProvice"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
    </b-col>
    <b-col md="6">
      <el-form-item label="Quận/Huyện">
        <el-select
          v-model="ruleForm.district"
          placeholder="Chọn Quận/Huyện"
          @change="getListCommune"
          :disabled="this.disabled"
          no-data-text="Chưa có thông tin"
          no-match-text="Không có dữ liệu"
        >
          <el-option
            v-for="item in listDistrict"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
    </b-col>
    <b-col md="6">
      <el-form-item label="Phường/Xã">
        <el-select
          v-model="ruleForm.commune"
          placeholder="Chọn Phường/Xã"
          @change="getCommune"
          :disabled="this.disabled"
          no-data-text="Chưa có thông tin"
          no-match-text="Không có dữ liệu"
        >
          <el-option
            v-for="item in listCommune"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
    </b-col>
    <b-col md="6">
      <el-form-item label="Địa chỉ">
        <el-input
          v-model="ruleForm.address"
          placeholder="Nhập địa chỉ chi tiết"
          @change="getAddress"
          :disabled="this.disabled"
        ></el-input>
      </el-form-item>
    </b-col>
  </b-row>
</template>

<script>
import mushroom from "viettoc-api";
import DataForm from "@/dataForm/dataFormDaiLy";
import MethodService from "@/service/MethodService";

export default {
  props: ["indexAddress", "info", "disabled"],
  data() {
    return {
      mData: {
        dataForm: MethodService.copyObject(DataForm.dataForm),
      },
      listProvice: [],
      listDistrict: [],
      listCommune: [],
      routerName: "",
      ruleForm: {
        provice: "",
        district: "",
        commune: "",
        address: "",
      },
    };
  },
  methods: {
    async getListProvice() {
      this.listProvice = [];
      try {
        const response = await mushroom.province.getAllAsync({
          limit: 100,
        });
        if (response.result && response.result.length > 0) {
          response.result.forEach((item) => {
            this.listProvice.push({
              value: item.id,
              label: item.type + " " + item.name,
            });
          });
        }
      } catch (e) {
        MethodService.showError(e.code);
      }
    },
    async getListDistrict(idProvince, routerName) {
      this.ruleForm.district = "";
      this.ruleForm.commune = "";
      if (routerName !== "CapNhatDaiLy") this.ruleForm.address = "";
      this.listCommune = [];
      this.listDistrict = [];
      this.$emit("idProvince", idProvince, this.indexAddress);
      try {
        const response = await mushroom.district.getAllAsync({
          fields: "id,disabled,code,name,provinceId,index,type,center",
          filters: ["provinceId=" + idProvince],
          sort: "name",
          limit: 100,
        });
        if (response.result && response.result.length > 0) {
          response.result.forEach((item) => {
            this.listDistrict.push({
              value: item.id,
              label: item.type + " " + item.name,
            });
          });
        }
      } catch (e) {
        MethodService.showError(e.code);
      }
    },

    async getListCommune(idDistrict) {
      this.ruleForm.commune = "";
      this.listCommune = [];
      this.$emit("idDistrict", idDistrict, this.indexAddress);

      try {
        const response = await mushroom.commune.getAllAsync({
          fields: "id,disabled,name,code,districtId,index,type,center",
          filters: ["districtId=" + idDistrict],
          sort: "name",
          limit: 100,
        });
        if (response.result && response.result.length > 0) {
          response.result.forEach((item) => {
            this.listCommune.push({
              value: item.id,
              label: item.type + " " + item.name,
            });
          });
        }
      } catch (e) {
        MethodService.showError(e.code);
      }
    },
    getCommune(idCommune) {
      this.$emit("idCommune", idCommune, this.indexAddress);
    },
    getAddress(address) {
      this.ruleForm.address = this.ruleForm.address.trim();
      this.$emit("address", address, this.indexAddress);
    },
  },
  watch: {
    info: async function () {
      if (this.info) {
        if (this.info.dia_chi) this.ruleForm.address = this.info.dia_chi;
        if (this.info.tinh_id) {
          this.ruleForm.provice = this.info.tinh_id;
          await this.getListDistrict(this.ruleForm.provice, this.routerName);
        }
        if (this.info.huyen_id) {
          this.ruleForm.district = this.info.huyen_id;
          await this.getListCommune(this.ruleForm.district);
        }
        if (this.info.xa_id) this.ruleForm.commune = this.info.xa_id;
      }
    },
  },
  async created() {
    this.routerName = this.$router.currentRoute.name;
    await this.getListProvice();
    this.ruleForm.address =
      this.info && this.info.dia_chi ? this.info.dia_chi : "";
    if (this.info && this.info.tinh_id) {
      this.ruleForm.provice = this.info.tinh_id;
      await this.getListDistrict(this.ruleForm.provice, this.routerName);
    }
    if (this.info && this.info.huyen_id) {
      this.ruleForm.district = this.info.huyen_id;
      await this.getListCommune(this.ruleForm.district);
    }

    this.ruleForm.commune =
      this.info && this.info.xa_id ? this.info.xa_id : undefined;
  },
};
</script>
